import { render, staticRenderFns } from "./AccommodationPriceCard.vue?vue&type=template&id=27b4a094"
import script from "./AccommodationPriceCard.vue?vue&type=script&lang=js"
export * from "./AccommodationPriceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports